import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import * as actions from '../../store/actions';

import Home from '../../pages/Home';
import LandingPage from '../../pages/LandingPage';
import About from '../../pages/About';
import Calendar from '../../pages/Calendar';
import Policies from '../../pages/Policies';
import Register from '../../pages/Register';
import Registration from '../../pages/Registration';
import Registration2 from '../../pages/Registration2';
import RegistrationThankYou from '../../pages/RegistrationThankYou';
import Registration2ThankYou from '../../pages/Registration2ThankYou';
import Schedule from '../../pages/Schedule';
import Staff from '../../pages/Staff';
import ThankYou from '../../pages/ThankYou';
import JobOpportunities from '../../pages/JobOpportunities';
import ContactUs from '../../pages/ContactUs';
import PrivacyPolicy from '../../pages/PrivacyPolicy';
import Admin from '../../pages/Admin';
import { getTextBlocks, getBanners, getCalendars, getStaff, getLocations, getPages } from '../../common/globalMethods';

const ApplicationContainer = (props) => {

	let {
		setCalendars,
		setLandingPageData,
		setLocations,
		setPages,
		setStaffList,
		setTextBlocks
	} = props;

	const [routes, setRoutes] = useState(null);

	useEffect(() => {

		getBanners().then(response => {
			setLandingPageData(response);
		}).catch(error => {
			console.warn("Error", error);
		});

		getCalendars().then(response => {
			setCalendars(response);
		}).catch(error => {
			console.warn("Error", error);
		});

		getStaff().then(response => {
			setStaffList(response);
		}).catch(error => {
			console.warn("Error", error);
		});

		getTextBlocks().then(response => {
			setTextBlocks(response);
		}).catch(error => {
			console.warn("Error", error);
		});

		getLocations().then(response => {
			setLocations(response);
		}).catch(error => {
			console.warn("Error", error);
		});

		getPages().then(response => {
			setRoutes(response);
			setPages(response);
		}).catch(error => {
			console.warn("Error", error);
		});

		// eslint-disable-next-line
	}, []);



	/*

	let pageRoutes = null;

	let i = 0;
	let j = 0;
	pageRoutes = (
	<React.Fragment>
	{lessonLocations.map(lessonLocation => {
	let locationRoute = null;
	if(lessonLocation && lessonLocation.Paths && lessonLocation.Paths.length > 0) {
	locationRoute = lessonLocation.Paths.map(path => {
	const currentRoute = (
	<Route key={j} path={path.Url}>
	<Home locationId={i} title={lessonLocation.Title} description={lessonLocation.Description} {...props} />
	</Route>
	);
	j++;
	return currentRoute;
	});
	}
	i++;
	return locationRoute;
	}
	)}
	</React.Fragment>
	);
	*/

	/*
	for (let i = 0; i < lessonLocations.length; i++) {
	const lessonLocation = lessonLocations[i];
	let locationRoute = null;
	console.warn('lessonLocation', lessonLocation);
	console.warn('lessonLocation.AboutText', lessonLocation.AboutText);
	// console.warn('lessonLocation.paths', lessonLocation.paths);
	if(lessonLocation && lessonLocation.Paths && lessonLocation.Paths.length > 0) {
	locationRoute = lessonLocation.Paths.map(path => {
	const currentRoute = (
	<Route path={path} render={(props) => <Home locationId={i} title={lessonLocation.Title} description={lessonLocation.Description} {...props} />} />
	);

	return currentRoute;
	});
	pageRoutes += locationRoute;
	}
	}
	}
	*/


	/*
	console.warn('pageRoutes', pageRoutes);

	const routes = (
	<Routes>
	{pageRoutes}
	<Route path="/" exact component={LandingPage} />
	<Redirect to="/" />
	</Switch>
	);
	*/

	if(routes == null) {
		// let imagePath = require('../../assets/images/Loading.svg').default;

		let imagePath = 'https://storage.googleapis.com/afterschool-music.appspot.com/images/Loading.svg';

		return <img src={imagePath} title='Loaading...' alt='Loading' />;
	} else {
		return (
			<Switch>
				{routes.map(route => {
					let component = null;
					// const menuItems = routes.filter(x => x.locationId == route.locationId);
					switch (route.component) {
						case 'About':
						component = <About locationId={route.locationId} title={route.pageTitle} description={route.pageDescription} textBlocks={route.textBlocks} />;
						break;
						case 'Calendar':
						component = <Calendar locationId={route.locationId} title={route.pageTitle} description={route.pageDescription} textBlocks={route.textBlocks} />;
						break;
						case 'Home':
						component = <Home locationId={route.locationId} title={route.pageTitle} description={route.pageDescription} textBlocks={route.textBlocks} />;
						break;
						case 'Policies':
						component = <Policies locationId={route.locationId} title={route.pageTitle} description={route.pageDescription} textBlocks={route.textBlocks} />;
						break;
						case 'Register':
						component = <Register locationId={route.locationId} title={route.pageTitle} description={route.pageDescription} textBlocks={route.textBlocks} />;
						break;
						case 'Schedule':
						component = <Schedule locationId={route.locationId} title={route.pageTitle} description={route.pageDescription} textBlocks={route.textBlocks} />;
						break;
						case 'Staff':
						component = <Staff locationId={route.locationId} title={route.pageTitle} description={route.pageDescription} textBlocks={route.textBlocks} />;
						break;
						case 'JobOpportunities':
						component = <JobOpportunities locationId={route.locationId} title={route.pageTitle} description={route.pageDescription} textBlocks={route.textBlocks} />;
						break;
						case 'ThankYou':
						component = <ThankYou locationId={route.locationId} title={route.pageTitle} description={route.pageDescription} textBlocks={route.textBlocks} />;
						break;
						case 'ContactUs':
						component = <ContactUs locationId={route.locationId} title={route.pageTitle} description={route.pageDescription} textBlocks={route.textBlocks} />;
						break;
						case 'PrivacyPolicy':
						component = <PrivacyPolicy locationId={route.locationId} title={route.pageTitle} description={route.pageDescription} textBlocks={route.textBlocks} />;
						break;
						default:
						component = null;
						break;
					}

					if(component == null) {
						return null;
					} else {
						if((route.subMenuItems && route.subMenuItems.length > 0) || route.component.toLowerCase() === 'thankyou') {
							return (
								<Route key={route.id} path={route.url}>{component}</Route>
							);
						} else {
							return (
								<Route key={route.id} exact path={route.url}>{component}</Route>
							);
						}
					}
				}
			)}
			<Route path="/Admin" exact component={Admin} />
			<Route path="/Registration" exact component={Registration} />
			<Route path="/Registration2" exact component={Registration2} />
			<Route path="/RegistrationThankYou" component={RegistrationThankYou} />
			<Route path="/Registration2ThankYou" component={Registration2ThankYou} />
			<Route path="/" exact component={LandingPage} />
			<Redirect to="/" />
		</Switch>
	);
}

/*

return routes;

return (
<div>
<Suspense fallback={<p>Loading...</p>}>{routes}</Suspense>
</div>
);
*/
};

const mapDispatchToProps = dispatch => {
	return {
		setCalendars: (calendars) => dispatch(actions.setCalendars(calendars)),
		setLandingPageData: (landingPageData) => dispatch(actions.setLandingPageData(landingPageData)),
		setLocations: (locationList) => dispatch(actions.setLocations(locationList)),
		setPages: (pageList) => dispatch(actions.setPages(pageList)),
		setStaffList: (staffList) => dispatch(actions.setStaffList(staffList)),
		setTextBlocks: (textBlocks) => dispatch(actions.setTextBlocks(textBlocks))
	};
};

export default withRouter(connect(null, mapDispatchToProps)(ApplicationContainer));
